import React from 'react';
import {
  ToolbarItem,
  SideNavLinkItemType,
} from '@amzn/aac-chrome-internal-api';
import AllToolsSideNavLink from './AllToolsSideNavLink';
import AllToolsToolbarItem from './AllToolsToolbarItem';
import AllToolsPanelButton from './AllToolsPanelButton';
import { getSingleAppLink } from 'src/features/nav/utils/toolbarItemLinks';

interface AllToolsNavItemProps {
  toolbarItem: ToolbarItem;
}

const AllToolsNavItem: React.VFC<AllToolsNavItemProps> = ({ toolbarItem }) => {
  const singleAppLink = getSingleAppLink(toolbarItem);

  if (singleAppLink) {
    if (singleAppLink.sidebarItemType === ('MODAL' as SideNavLinkItemType)) {
      return <AllToolsPanelButton toolbarItem={toolbarItem} />;
    }
    return (
      <AllToolsSideNavLink
        key={toolbarItem.id}
        id={toolbarItem.id}
        isFromAllTools={true}
        isQuickNavModalEnabled={true}
      />
    );
  }

  return <AllToolsToolbarItem toolbarItem={toolbarItem} />;
};

export default AllToolsNavItem;
